import http from "@/core/api/http";

export const authAPI = {
    /** 登录（密码/TOTP） */
    login: (data) => {
        return http.post(`/auth/tokens`, data);
    },
    /** 注册（成功直返 token） */
    register: (data) => {
        return http.post(`/auth/register`, data);
    },
    /** 为当前 Bearer 会话申领 TOTP 二维码 */
    getTotpQR: () => {
        return http.post(`/auth/claim`);
    },
};
